module.exports = __webpack_public_path__ + "img/navitas_logotype_white.9b0d4c69.png";